import React from 'react';

export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.25rem"
      height="1rem"
      viewBox="0 0 20 16"
      version="1.1">
      <title>noun-down-6516159</title>
      <g
        id="10/22/24"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="10-18-DE---Images-tab---hover-over-unedited-images"
          transform="translate(-878, -989)"
          fill="#F57C00"
          fillRule="nonzero">
          <g id="noun-down-6516159" transform="translate(877.9997, 989)">
            <path
              d="M9.43096757,8.05303915 C9.77353733,8.29004371 10.2270978,8.29004371 10.5696676,8.05303915 L19.5696676,1.82303915 C20.0237837,1.50859583 20.1370109,0.885555285 19.8225676,0.431439149 C19.5081242,-0.0226769863 18.8850837,-0.135904173 18.4309676,0.178539149 L10.0002676,6.01433915 L1.56956757,0.177939149 C1.11545143,-0.136476545 0.49243329,-0.0232269675 0.178017587,0.430889161 C-0.136398117,0.88500529 -0.0231485529,1.50802344 0.430967569,1.82243915 L9.43096757,8.05303915 Z"
              id="Path"
            />
            <path
              d="M0.430967569,9.43763915 L9.43096757,15.6676391 C9.77353733,15.9046437 10.2270978,15.9046437 10.5696676,15.6676391 L19.5696676,9.43763915 C20.0238113,9.12319582 20.1370609,8.50013291 19.8226175,8.04598917 C19.5081742,7.59184543 18.8851113,7.47859585 18.4309676,7.79303915 L10.0002676,13.6295391 L1.56956757,7.79303915 C1.11545143,7.47859584 0.492410907,7.59182304 0.17796759,8.04593916 C-0.136475726,8.50005529 -0.0232485499,9.12309582 0.430867569,9.43753915 L0.430967569,9.43763915 Z"
              id="Path"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
